import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Table } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import jsPDF from 'jspdf'
import * as html2canvas from 'html2canvas';
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import QRCodeStyling from "qr-code-styling";
import { Icon } from '@iconify/react';
// import CryptoJS from 'crypto-js';
// import "./invoice.css";
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const qrCode = new QRCodeStyling({
  width: 100,
  height: 100,
  id:new Date().getTime(),
  image: require("../assets/images/logo/logo-icon.png"),
  dotsOptions: {
    color: "#211833",
    type: "rounded"
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 5
  }
});

const Invoice = (props) => {
  console.warn = () => {}
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  const [billdate, setbilldate] = useState('');

  const [inventory_costperunit, setinventory_costperunit] = useState('');
  const [billstatus, setbillstatus] = useState('');
  const [inventory, setinventory] = useState('');
  const [inventory_quantity, setinventory_quantity] = useState('');
  const [inventory_price, setinventory_price] = useState('');
  const [inventory_total, setinventory_total] = useState('');
  const [buyer_name, setbuyer_name] = useState('');
  const [buyer_address, setbuyer_address] = useState('');
  const [buyer_gstno, setbuyer_gstno] = useState('');
  const [supplier_name, setsupplier_name] = useState('');
  const [supplier_address, setsupplier_address] = useState('');
  const [supplier_gstno, setsupplier_gstno] = useState('');
  const [paid_at, setpaid_at] = useState('');
  const [inventory_unit, setinventory_unit] = useState('');
  const [payment_type, setpayment_type] = useState('');
  const [invoice_id, setinvoice_id] = useState('');
  const [vehicle_invoice_id, setvehicle_invoice_id] = useState('');
  const [pick_up, setpick_up] = useState('');
  const [drop_off, setdrop_off] = useState('');
  const [vehicle_no, setvehicle_no] = useState('');
  const [vehicle_type, setvehicle_type] = useState('');

  const [vehicle_owner_contact, setvehicle_owner_contact] = useState('');
  const [driver_name, setdriver_name] = useState('');
  const [driver_contact, setdriver_contact] = useState('');

  const [driver_licence, setdriver_licence] = useState('');
  const [transport_distance, settransport_distance] = useState('');
  const [transport_charges, settransport_charges] = useState('');

  const [trip_status, settrip_status] = useState(0)
  const [trip_type, settrip_type] = useState([{
    trip_name: "Trip Invoice",
  }, {
    trip_name: "Transport Invoice",
  }])

  const [url, setUrl] = useState(window.location.href);

  const ref = useRef(null);
  const params = useParams();
  require("./invoice.css");
  require("./invoicevehicle.css");
  useEffect(() => {
    qrCode.append(ref.current);
    window.localStorage.setItem('usertype',params.type)
    setTimeout(()=>{
      updateInvoice(0)
    },1000)
  }, [])
  useEffect(() => {
    settrip_type([{
      trip_name: "Trip Invoice",
    }, {
      trip_name: "Transport Invoice",
    }])
    setUrl(window.location.href);
    qrCode.update({
      data: url
    });
  }, [url]);


  async function updateInvoice(index) {
   
    if (window.localStorage.getItem('usertype') === 'Vehicle Owner') {
      let { data: invoice_detail, error } = await supabase
        .from('vehicle_invoice_details')
        .select('*')
        .eq('vehicle_invoice_id', params.id)
      if (invoice_detail !== null && invoice_detail.length > 0) {
        setbilldate(invoice_detail[0].vehicle_invoice_date)

        setinvoice_id(params.id)

        setbillstatus(invoice_detail[0].payment_status)

        setbuyer_name(invoice_detail[0].customer_name)
        setbuyer_address(invoice_detail[0].customer_address)
        setbuyer_gstno(invoice_detail[0].customer_gst)
        setsupplier_name(invoice_detail[0].man_name)
        setsupplier_address(invoice_detail[0].man_address)
        setsupplier_gstno(invoice_detail[0].man_gstnumber)
        setdriver_name(invoice_detail[0].driver_name)

        setdriver_contact(invoice_detail[0].driver_contact_no)
        setdriver_licence(invoice_detail[0].driver_license_no)
        setvehicle_no(invoice_detail[0].vehicle_no)
        setvehicle_type(invoice_detail[0].vehicle_type)
        setvehicle_owner_contact(invoice_detail[0].vehicle_owner_no)
        settransport_distance(invoice_detail[0].transport_distance)
        settransport_charges(invoice_detail[0].transport_charges)
       
        setpick_up(invoice_detail[0].pick_up)
        setdrop_off(invoice_detail[0].drop_off)
        setpayment_type(invoice_detail[0].payment_type)


      }else{
        if(error){}
      }
    } else {
      if (window.localStorage.getItem('usertype') === 'Buyer') {
       
        if (index === 0) {
          qrCode.update({
            data: url
          });
          qrCode.append(ref.current);
          let { data: invoice_detail, error } = await supabase
            .from('invoice_details')
            .select('*')
            .eq('trip_id', params.id)
          if (invoice_detail !== null && invoice_detail.length > 0) {
            setbilldate(invoice_detail[0].invoice_date)

            setinvoice_id(invoice_detail[0].invoice_id)
            setinventory_costperunit(invoice_detail[0].inventory_costperunit)
            setbillstatus(invoice_detail[0].payment_status)
            setinventory(invoice_detail[0].inventory_type)
            setinventory_quantity(invoice_detail[0].inventory_quantity)
            setinventory_unit(invoice_detail[0].inventory_unit)
            setinventory_price(invoice_detail[0].inventory_cost)
            setinventory_total(invoice_detail[0].inventory_cost)
            setbuyer_name(invoice_detail[0].customer_name)
            setbuyer_address(invoice_detail[0].customer_address)
            setbuyer_gstno(invoice_detail[0].customer_gstnumber)
            setsupplier_name(invoice_detail[0].man_name)
            setsupplier_address(invoice_detail[0].man_address)
            setsupplier_gstno(invoice_detail[0].man_gstnumber)
            setpaid_at(invoice_detail[0].paid_at)
            setpayment_type(invoice_detail[0].payment_type)
          }else{
            if(error){}
          }
        } else {
          qrCode.update({
            data: url
          });
          qrCode.append(ref.current);
          
          let { data: invoice_detail, error } = await supabase
            .from('vehicle_invoice_details')
            .select('*')
            .eq('trip_id', params.id)
            
          if (invoice_detail !== null && invoice_detail.length > 0) {
            setbilldate(invoice_detail[0].vehicle_invoice_date)

            setvehicle_invoice_id(invoice_detail[0].vehicle_invoice_id)

            setbillstatus(invoice_detail[0].payment_status)

            setbuyer_name(invoice_detail[0].customer_name)
            setbuyer_address(invoice_detail[0].customer_address)
            setbuyer_gstno(invoice_detail[0].customer_gst)
            setsupplier_name(invoice_detail[0].man_name)
            setsupplier_address(invoice_detail[0].man_address)
            setsupplier_gstno(invoice_detail[0].man_gstnumber)
            setdriver_name(invoice_detail[0].driver_name)

            setdriver_contact(invoice_detail[0].driver_contact_no)
            setdriver_licence(invoice_detail[0].driver_license_no)
            setvehicle_no(invoice_detail[0].vehicle_no)
            setvehicle_type(invoice_detail[0].vehicle_type)
            setvehicle_owner_contact(invoice_detail[0].vehicle_owner_no)
            settransport_distance(invoice_detail[0].transport_distance)
            settransport_charges(invoice_detail[0].transport_charges)
            
            setpick_up(invoice_detail[0].pick_up)
            setdrop_off(invoice_detail[0].drop_off)
            setpayment_type(invoice_detail[0].payment_type)


          }else{
            if(error){}
          }

        }




      } else {
        let { data: invoice_detail, error } = await supabase
          .from('invoice_details')
          .select('*')
          .eq('invoice_id', params.id)
        if (invoice_detail !== null && invoice_detail.length > 0) {
          setbilldate(invoice_detail[0].invoice_date)

          setinvoice_id(params.id)
          setinventory_costperunit(invoice_detail[0].inventory_costperunit)
          setbillstatus(invoice_detail[0].payment_status)
          setinventory(invoice_detail[0].inventory_type)
          setinventory_quantity(invoice_detail[0].inventory_quantity)
          setinventory_unit(invoice_detail[0].inventory_unit)
          setinventory_price(invoice_detail[0].inventory_cost)
          setinventory_total(invoice_detail[0].inventory_cost)
          setbuyer_name(invoice_detail[0].customer_name)
          setbuyer_address(invoice_detail[0].customer_address)
          setbuyer_gstno(invoice_detail[0].customer_gstnumber)
          setsupplier_name(invoice_detail[0].man_name)
          setsupplier_address(invoice_detail[0].man_address)
          setsupplier_gstno(invoice_detail[0].man_gstnumber)
          setpaid_at(invoice_detail[0].paid_at)
          setpayment_type(invoice_detail[0].payment_type)


        }else{
          if(error){}
        }

      }
    }
  }



  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];


  function convertdate(data) {
    var date = new Date(data)
    var day_date = date.getDate()
    var month = date.getMonth()
    var year = date.getFullYear()
    day_date = day_date < 10 ? '0' + day_date : day_date;


    var newdate = day_date + "-" + monthNames[month] + "-" + year
    return newdate
  }
  function converttime(tripdate) {
    var date = new Date(tripdate)
    var day_date = date.getDate()
    var month = date.getMonth()

    var year = date.getFullYear()
    var hours = date.getHours();
    var minutes = date.getMinutes();
    day_date = day_date < 10 ? '0' + day_date : day_date;


    var newdate = day_date + "-" + monthNames[month] + "-" + year + " " + hours + ":" + minutes
    return newdate
  }
  const handlePdf = () => {
    let downloadSection = "";
    if (window.localStorage.getItem('usertype') === 'Vehicle Owner') {
      downloadSection = document.getElementById("download_section");
    } else if(window.localStorage.getItem('usertype') === 'Buyer') {
      if(trip_status === 0){
        downloadSection = document.getElementById('tm_download_section');
      }else{
        downloadSection = document.getElementById("download_section");
      }
      
    }else{
      downloadSection = document.getElementById('tm_download_section');
    }





    html2canvas(downloadSection).then(function (
      canvas
    ) {
      var cWidth = canvas.width;
      var cHeight = canvas.height;
      var topLeftMargin = 0;
      var pdfWidth = cWidth + topLeftMargin * 2;
      var pdfHeight = pdfWidth * 1.5 + topLeftMargin * 2;
      var canvasImageWidth = cWidth;
      var canvasImageHeight = cHeight;
      var totalPDFPages = Math.ceil(cHeight / pdfHeight) - 1;
      canvas.getContext('2d');
      var imgData = canvas.toDataURL('image/png', 1.0);
      var pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
      pdf.addImage(
        imgData,
        'PNG',
        topLeftMargin,
        topLeftMargin,
        canvasImageWidth,
        canvasImageHeight
      );
      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(pdfWidth, pdfHeight);
        pdf.addImage(
          imgData,
          'PNG',
          topLeftMargin,
          -(pdfHeight * i) + topLeftMargin * 0,
          canvasImageWidth,
          canvasImageHeight
        );
      }
      pdf.save('Invoice.pdf');
    });
  }


  return (
    <Fragment>
      {window.localStorage.getItem('usertype') === 'Vehicle Owner' ?
        <div className="cs-container">
          <div className='tm_hide_print button-section'>
           {window.localStorage.getItem("currentUser") != "null"?<> {window.innerWidth<800?
            <button className="btn  " style={{borderRadius:"10px",padding:"10px"}} onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} ><Icon icon="codicon:arrow-small-left" color="gray" width="50" height="50" /></button>:
            <button className="btn btn-primary " onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} >Back</button>}</>:""}
            <div className="cs-invoice_btns ">
              <div className="cs-invoice_btn cs-color1" onClick={() => { window.print() }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><rect x="128" y="240" width="256" height="208" rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><circle cx="392" cy="184" r="24" /></svg>
                <span>Print</span>
              </div>
              <button id="download_btn" className="cs-invoice_btn cs-color2" onClick={() => { handlePdf() }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><title>Download</title><path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M176 272l80 80 80-80M256 48v288" /></svg>
                <span>Download</span>
              </button>
            </div>
          </div>
          <div className="cs-invoice cs-style1">
            <div className="cs-invoice_in" id="download_section">
              <div className="cs-invoice_head cs-type1 ">
              <div className="cs-invoice-left"><p className="tm_m0"><span ref={ref} /></p>
              &nbsp;
               
                 
                </div>
                <div className="cs-invoice_right cs-text_right">
                  <div className="cs-logo cs-mb5"><img src={require("../assets/images/logo/login.png")} alt="Logo" /></div>
                </div>
                
              </div>
              <div style={{borderBottom: "1px solid #eaeaea",marginBottom:"25px"}}>
                  <p className="cs-invoice_number cs-primary_color cs-mb5 cs-f16"><b className="cs-primary_color">Invoice NO:</b><b>{vehicle_invoice_id}</b> </p>
                  <p className="cs-invoice_date cs-primary_color cs-m0"><b className="cs-primary_color">Invoice Date: </b><b>{convertdate(billdate)}</b></p>
                  </div>
              

              <ul className="cs-grid_row cs-col_3 cs-mb10" style={{margin:" 0 0 25px 0"}}>
                <li className="cs-mb20">
                  <b className="cs-primary_color">Pick-Up:</b>
                  <p className="cs-mb0">
                    {supplier_name} <br />
                    {supplier_address}<br />
                    GST IN: {supplier_gstno} <br />
                    {convertdate(pick_up)}
                  </p>
                </li>
                <li className="cs-mb20">
                  <b className="cs-primary_color">Drop-off:</b>
                  <p className="cs-mb0">
                    {buyer_name} <br />
                    {buyer_address} <br />
                    GST IN: {buyer_gstno} <br />
                    {convertdate(drop_off)}
                  </p>
                </li>
                <li className="cs-mb20">
                  <div className="cs-box cs-style1 cs-type1 cs-text_center cs-max_w_150 cs-left_auto">
                    <p className="cs-mb5">Upto</p>
                    <p className="cs-accent_color cs-f24 cs-bold cs-mb0">{transport_distance} KM</p>
                  </div>
                </li>
              </ul>

              <div className="cs-box2_wrap cs-mb30">
                <div className=" cs-box cs-style2">
                  <p className="cs-primary_color cs-semi_bold cs-f18 cs-mb5">Vehicle Information</p>
                  <div className="cs-table cs-style2">
                    <table>
                      <tbody>

                        <tr>
                          <td><b className="cs-primary_color cs-semi_bold">Vehicle Type:</b> {vehicle_type}</td>
                        </tr>
                        <tr>
                          <td><b className="cs-primary_color cs-semi_bold">Vehicle NO:</b> {vehicle_no}</td>
                        </tr>
                        <tr>
                          <td><b className="cs-primary_color cs-semi_bold">Contact:</b> +91-{vehicle_owner_contact.toString().slice(2, 12)}</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className=" cs-box cs-style2">
                  <p className="cs-primary_color cs-semi_bold cs-f18 cs-mb5">Driver Information</p>
                  <div className="cs-table cs-style2">
                    <table>
                      <tbody>
                        <tr>
                          <td><b className="cs-primary_color cs-semi_bold">Driver Name:</b> {driver_name}</td>
                        </tr>
                        <tr>
                          <td><b className="cs-primary_color cs-semi_bold">Driving Licence:</b> {driver_licence}</td>
                        </tr>

                        <tr>
                          <td><b className="cs-primary_color cs-semi_bold">Contact:</b> +91-{driver_contact.toString().slice(2, 12)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="cs-table cs-style2">
                <div className="cs-round_border">
                  <div className="cs-table_responsive">
                    <table>
                      <thead>
                        <tr className="cs-focus_bg">
                          <th className="cs-width_6 cs-semi_bold cs-primary_color">Items Details</th>
                          <th className="cs-width_2 cs-semi_bold cs-primary_color">Price</th>
                          <th className="cs-width_2 cs-semi_bold cs-primary_color">Tax</th>
                          <th className="cs-width_2 cs-semi_bold cs-primary_color cs-text_right">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="cs-width_6">{vehicle_type}</td>
                          <td className="cs-width_2">{transport_charges}</td>
                          <td className="cs-width_2">5%</td>
                          <td className="cs-width_2 cs-text_right cs-primary_color cs-semi_bold">{parseInt(transport_charges) + (parseInt(transport_charges) * 5) / 100}</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="cs-table cs-style2">
                <div className="cs-table_responsive">
                  <table>
                    <tbody>
                      <tr className="cs-table_baseline">
                        <td className="cs-width_5">
                          <b className="cs-primary_color">Pay By</b><br />
                          {payment_type} <br />Amount: Rs {parseInt(transport_charges) + (parseInt(transport_charges) * 5) / 100}
                        </td>
                        <td className="cs-width_5 cs-primary_color cs-bold cs-f16 cs-text_right">Total Amount:</td>
                        <td className="cs-width_2 cs-text_right cs-primary_color cs-bold cs-primary_color cs-f16">Rs {parseInt(transport_charges) + (parseInt(transport_charges) * 5) / 100}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="cs-note">
                <div className="cs-note_left">
                  <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><path d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /></svg>
                </div>
                <div className="cs-note_right">
                  <p className="cs-mb0"><b className="cs-primary_color cs-bold">Terms & Conditions</b></p>
                  <p className="cs-m0">Invoice was created on a computer and is valid without the signature and seal.</p>
                </div>
              </div>
            </div>

          </div>
        </div> :
        <>{window.localStorage.getItem('usertype') === 'Buyer' ? <>
          {trip_status === 0 ?
            <div className="tm_container" id="invoice">
              <div className='tm_hide_print button-section'>
              {window.localStorage.getItem("currentUser") != "null"?<> {window.innerWidth<800?
            <button className="btn  " style={{borderRadius:"10px",padding:"10px"}} onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} ><Icon icon="codicon:arrow-small-left" color="gray" width="50" height="50" /></button>:
            <button className="btn btn-primary " onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} >Back</button>}</>:""}
                <div className="cs-invoice_btns ">
                  <div className="cs-invoice_btn cs-color1" onClick={() => { window.print() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><rect x="128" y="240" width="256" height="208" rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><circle cx="392" cy="184" r="24" /></svg>
                    <span>Print</span>
                  </div>
                  <button id="download_btn" className="cs-invoice_btn cs-color2" onClick={() => { handlePdf() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><title>Download</title><path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M176 272l80 80 80-80M256 48v288" /></svg>
                    <span>Download</span>
                  </button>

                </div>

              </div>
              <div className="tm_hide_print">
                <Table className='table-borderless'>
                  <tbody>
                    <tr style={{ display: "flex", alignItems: "center" }}>
                      {trip_type.length > 0 && trip_type.map((item, index) => {
                        return (

                          <td style={{ verticalAlign: "inherit" }} key={index}>

                            <button className="btn " style={{ backgroundColor: index === trip_status ? "#E50014" : "whitesmoke", color: index !== trip_status ? "black" : "white", borderRadius: "5px" }} onClick={() => { settrip_status(index) ;updateInvoice(index)}}>{item.trip_name}</button>
                          </td>
                        )
                      })}


                    </tr>
                  </tbody>
                </Table>
              </div>

              <div className="tm_invoice_wrap">
                <div className="tm_invoice tm_style1 tm_type1" id="tm_download_section">
                  <div className="tm_invoice_in">
                    <div className="tm_invoice_head tm_top_head tm_mb15 tm_align_center">
                      <div className="tm_invoice_left">
                        <div className="tm_logo"><img src={require("../assets/images/logo/login.png")} alt="Logo" /></div>
                      </div>
                      <div className="tm_invoice_right tm_text_right tm_mobile_hide">
                        <div className="tm_f50 tm_text_uppercase tm_white_color">Invoice</div>
                      </div>
                      <div className="tm_shape_bg tm_accent_bg tm_mobile_hide"></div>
                    </div>
                    <div className="tm_invoice_info tm_mb25">
                      <div className="tm_card_note tm_mobile_hide"><b className="tm_primary_color">Payment Method: </b>{payment_type}</div>
                      <div className="tm_invoice_info_list tm_white_color">
                        <p className="tm_invoice_number tm_m0">Invoice No: <b>{invoice_id}</b></p>
                        <p className="tm_invoice_date tm_m0">Date: <b>{convertdate(billdate)}</b></p>
                      </div>
                      <div className="tm_invoice_seperator tm_accent_bg"></div>
                    </div>
                    <div className="tm_invoice_head tm_mb10">

                      <div className="tm_invoice_left">
                        <p className="tm_mb2"><b className="tm_primary_color">Invoice To:</b></p>
                        <p>
                          {buyer_name} <br />
                          {buyer_address}<br />
                          GSTIN: {buyer_gstno}


                        </p>
                      </div>
                      <div className="tm_invoice_right tm_text_right">
                        <p className="tm_mb2"><b className="tm_primary_color">Invoice From:</b></p>
                        <p>
                          {supplier_name} <br />
                          {supplier_address}<br />
                          GSTIN: {supplier_gstno}
                        </p>
                      </div>
                    </div>
                    <div className="tm_table tm_style1">
                      <div className="">
                        <div className="tm_table_responsive">
                          <table>
                            <thead>
                              <tr className="tm_accent_bg">
                                <th className="tm_width_3 tm_semi_bold tm_white_color">Inventory</th>
                                <th className="tm_width_4 tm_semi_bold tm_white_color">Description</th>
                                <th className="tm_width_1 tm_semi_bold tm_white_color">Qty</th>
                                <th className="tm_width_2 tm_semi_bold tm_white_color">Unit</th>
                                <th className="tm_width_4 tm_semi_bold tm_white_color">Cost Per Unit</th>
                                <th className="tm_width_2 tm_semi_bold tm_white_color tm_text_right">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="tm_width_3">{inventory}</td>
                                <td className="tm_width_4">Material</td>
                                <td className="tm_width_1">{inventory_quantity}</td>
                                <td className="tm_width_1">{inventory_unit}</td>
                                <td className="tm_width_2">{inventory_costperunit}</td>
                                <td className="tm_width_2 tm_text_right">{inventory_price}</td>
                              </tr>


                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="tm_invoice_footer tm_border_top tm_mb15 tm_m0_md">
                        <div className="tm_left_footer">
                          <p className="tm_mb2"><b className="tm_primary_color">Payment info:</b></p>
                          <p className="tm_m0">{paid_at !== "" ? converttime(paid_at) : ""} <br />{billstatus}<br />Amount: {(parseInt(inventory_total)) + (((parseInt(inventory_total)) * 18) / 100)}</p>
                          <br />
                          <p className="tm_m0"><span ref={ref} /></p>
                        </div>
                        <div className="tm_right_footer">
                          <table className="tm_mb15">
                            <tbody>
                              <tr className="tm_gray_bg ">
                                <td className="tm_width_3 tm_primary_color tm_bold">Subtotal</td>
                                <td className="tm_width_3 tm_primary_color tm_bold tm_text_right">Rs. {parseInt(inventory_total)}</td>
                              </tr>
                              <tr className="tm_gray_bg">
                                <td className="tm_width_3 tm_primary_color">SGST <span className="tm_ternary_color">(9%)</span></td>
                                <td className="tm_width_3 tm_primary_color tm_text_right">Rs. {((parseInt(inventory_total)) * 9) / 100}</td>
                              </tr>
                              <tr className="tm_gray_bg">
                                <td className="tm_width_3 tm_primary_color">CGST <span className="tm_ternary_color">(9%)</span></td>
                                <td className="tm_width_3 tm_primary_color tm_text_right">Rs. {((parseInt(inventory_total)) * 9) / 100}</td>
                              </tr>
                              <tr className="tm_accent_bg">
                                <td className="tm_width_3 tm_border_top_0 tm_bold tm_f16 tm_white_color">Grand Total	</td>
                                <td className="tm_width_3 tm_border_top_0 tm_bold tm_f16 tm_white_color tm_text_right">Rs. {(parseInt(inventory_total)) + (((parseInt(inventory_total)) * 18) / 100)}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                    <div className="tm_note tm_text_center tm_font_style_normal">
                      <hr className="tm_mb15" />
                      <p className="tm_mb2"><b className="tm_primary_color">Terms & Conditions:</b></p>
                      <p className="tm_m0">Invoice was created on a computer and is valid without the signature and seal.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div> : 
            <div className="cs-container">
              <div className='tm_hide_print button-section'>
              {window.localStorage.getItem("currentUser") != "null"?<> {window.innerWidth<800?
            <button className="btn  " style={{borderRadius:"10px",padding:"10px"}} onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} ><Icon icon="codicon:arrow-small-left" color="gray" width="50" height="50" /></button>:
            <button className="btn btn-primary " onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} >Back</button>}</>:""}
                <div className="cs-invoice_btns ">
                  <div className="cs-invoice_btn cs-color1" onClick={() => { window.print() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><rect x="128" y="240" width="256" height="208" rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><circle cx="392" cy="184" r="24" /></svg>
                    <span>Print</span>
                  </div>
                  <button id="download_btn" className="cs-invoice_btn cs-color2" onClick={() => { handlePdf() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><title>Download</title><path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M176 272l80 80 80-80M256 48v288" /></svg>
                    <span>Download</span>
                  </button>
                </div>
              </div>
              <div className="tm_hide_print">
                <Table className='table-borderless'>
                  <tbody>
                    <tr style={{ display: "flex", alignItems: "center" }}>
                      {trip_type.length > 0 && trip_type.map((item, index) => {
                        return (

                          <td style={{ verticalAlign: "inherit" }} key={index}>

                            <button className="btn " style={{ backgroundColor: index === trip_status ? "#E50014" : "whitesmoke", color: index !== trip_status ? "black" : "white", borderRadius: "5px" }} onClick={() => { settrip_status(index) ;updateInvoice(index)}}>{item.trip_name}</button>
                          </td>
                        )
                      })}


                    </tr>
                  </tbody>
                </Table>
              </div>
              <div className="cs-invoice cs-style1">
                <div className="cs-invoice_in" id="download_section">
                  <div className="cs-invoice_head cs-type1 ">
                    <div className="cs-invoice-left"><p className="tm_m0"><span ref={ref} /></p>
                  
                     
                    </div>
                    <div className="cs-invoice_right cs-text_right">
                      <div className="cs-logo cs-mb5"><img src={require("../assets/images/logo/login.png")} alt="Logo" /></div>
                    </div>
                  </div>
                  <div style={{borderBottom: "1px solid #eaeaea",marginBottom:"25px"}}>
                  <p className="cs-invoice_number cs-primary_color cs-mb5 cs-f16"><b className="cs-primary_color">Invoice NO:</b><b>{vehicle_invoice_id}</b> </p>
                  <p className="cs-invoice_date cs-primary_color cs-m0"><b className="cs-primary_color">Invoice Date: </b><b>{convertdate(billdate)}</b></p>
                  </div>

                  <ul className="cs-grid_row cs-col_3 cs-mb10" style={{margin:" 0 0 25px 0"}}>
                    <li className="cs-mb20">
                      <b className="cs-primary_color">Pick-Up:</b>
                      <p className="cs-mb0">
                        {supplier_name} <br />
                        {supplier_address}<br />
                        GST IN: {supplier_gstno} <br />
                        {convertdate(pick_up)}
                      </p>
                    </li>
                    <li className="cs-mb20">
                      <b className="cs-primary_color">Drop-off:</b>
                      <p className="cs-mb0">
                        {buyer_name} <br />
                        {buyer_address} <br />
                        GST IN: {buyer_gstno} <br />
                        {convertdate(drop_off)}
                      </p>
                    </li>
                    <li className="cs-mb20">
                      <div className="cs-box cs-style1 cs-type1 cs-text_center cs-max_w_150 cs-left_auto">
                        <p className="cs-mb5">Upto</p>
                        <p className="cs-accent_color cs-f24 cs-bold cs-mb0">{transport_distance} KM</p>
                      </div>
                    </li>
                  </ul>

                  <div className="cs-box2_wrap cs-mb30">
                    <div className=" cs-box cs-style2">
                      <p className="cs-primary_color cs-semi_bold cs-f18 cs-mb5">Vehicle Information</p>
                      <div className="cs-table cs-style2">
                        <table>
                          <tbody>

                            <tr>
                              <td><b className="cs-primary_color cs-semi_bold">Vehicle Type:</b> {vehicle_type}</td>
                            </tr>
                            <tr>
                              <td><b className="cs-primary_color cs-semi_bold">Vehicle NO:</b> {vehicle_no}</td>
                            </tr>
                            <tr>
                              <td><b className="cs-primary_color cs-semi_bold">Contact:</b> +91-{vehicle_owner_contact.toString().slice(2, 12)}</td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className=" cs-box cs-style2">
                      <p className="cs-primary_color cs-semi_bold cs-f18 cs-mb5">Driver Information</p>
                      <div className="cs-table cs-style2">
                        <table>
                          <tbody>
                            <tr>
                              <td><b className="cs-primary_color cs-semi_bold">Driver Name:</b> {driver_name}</td>
                            </tr>
                            <tr>
                              <td><b className="cs-primary_color cs-semi_bold">Driving Licence:</b> {driver_licence}</td>
                            </tr>

                            <tr>
                              <td><b className="cs-primary_color cs-semi_bold">Contact:</b> +91-{driver_contact.toString().slice(2, 12)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="cs-table cs-style2">
                    <div className="cs-round_border">
                      <div className="cs-table_responsive">
                        <table>
                          <thead>
                            <tr className="cs-focus_bg">
                              <th className="cs-width_6 cs-semi_bold cs-primary_color">Items Details</th>
                              <th className="cs-width_2 cs-semi_bold cs-primary_color">Price</th>
                              <th className="cs-width_2 cs-semi_bold cs-primary_color">Tax</th>
                              <th className="cs-width_2 cs-semi_bold cs-primary_color cs-text_right">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="cs-width_6">{vehicle_type}</td>
                              <td className="cs-width_2">{transport_charges}</td>
                              <td className="cs-width_2">5%</td>
                              <td className="cs-width_2 cs-text_right cs-primary_color cs-semi_bold">{parseInt(transport_charges) + (parseInt(transport_charges) * 5) / 100}</td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="cs-table cs-style2">
                    <div className="cs-table_responsive">
                      <table>
                        <tbody>
                          <tr className="cs-table_baseline">
                            <td className="cs-width_5">
                              <b className="cs-primary_color">Pay By</b><br />
                              {payment_type} <br />Amount: Rs {parseInt(transport_charges) + (parseInt(transport_charges) * 5) / 100}
                            </td>
                            <td className="cs-width_5 cs-primary_color cs-bold cs-f16 cs-text_right">Total Amount:</td>
                            <td className="cs-width_2 cs-text_right cs-primary_color cs-bold cs-primary_color cs-f16">Rs {parseInt(transport_charges) + (parseInt(transport_charges) * 5) / 100}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="cs-note">
                    <div className="cs-note_left">
                      <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><path d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /></svg>
                    </div>
                    <div className="cs-note_right">
                      <p className="cs-mb0"><b className="cs-primary_color cs-bold">Terms & Conditions</b></p>
                      <p className="cs-m0">Invoice was created on a computer and is valid without the signature and seal.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>}</> :
          <div className="tm_container" id="invoice">
            <div className='tm_hide_print button-section'>
 
            {window.localStorage.getItem("currentUser") != "null"?<> {window.innerWidth<800?
            <button className="btn  " style={{borderRadius:"10px",padding:"10px"}} onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} ><Icon icon="codicon:arrow-small-left" color="gray" width="50" height="50" /></button>:
            <button className="btn btn-primary " onClick={() => { window.localStorage.removeItem("invoice"); window.history.back() }} >Back</button>}</>:""}
              <div className="cs-invoice_btns ">
                <div className="cs-invoice_btn cs-color1" onClick={() => { window.print() }}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><rect x="128" y="240" width="256" height="208" rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" /><circle cx="392" cy="184" r="24" /></svg>
                  <span>Print</span>
                </div>
                <button id="download_btn" className="cs-invoice_btn cs-color2" onClick={() => { handlePdf() }}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><title>Download</title><path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M176 272l80 80 80-80M256 48v288" /></svg>
                  <span>Download</span>
                </button>
              </div>
            </div>
            <br />
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1" id="tm_download_section">
                <div className="tm_invoice_in">
                  <div className="tm_invoice_head tm_top_head tm_mb15 tm_align_center">
                    <div className="tm_invoice_left">
                      <div className="tm_logo"><img src={require("../assets/images/logo/login.png")} alt="Logo" /></div>
                    </div>
                    <div className="tm_invoice_right tm_text_right tm_mobile_hide">
                      <div className="tm_f50 tm_text_uppercase tm_white_color">Invoice</div>
                    </div>
                    <div className="tm_shape_bg tm_accent_bg tm_mobile_hide"></div>
                  </div>
                  <div className="tm_invoice_info tm_mb25">
                    <div className="tm_card_note tm_mobile_hide"><b className="tm_primary_color">Payment Method: </b>{payment_type}</div>
                    <div className="tm_invoice_info_list tm_white_color">
                      <p className="tm_invoice_number tm_m0">Invoice No: <b>{invoice_id}</b></p>
                      <p className="tm_invoice_date tm_m0">Date: <b>{convertdate(billdate)}</b></p>
                    </div>
                    <div className="tm_invoice_seperator tm_accent_bg"></div>
                  </div>
                  <div className="tm_invoice_head tm_mb10">

                    <div className="tm_invoice_left">
                      <p className="tm_mb2"><b className="tm_primary_color">Invoice To:</b></p>
                      <p>
                        {buyer_name} <br />
                        {buyer_address}<br />
                        GSTIN: {buyer_gstno}


                      </p>
                    </div>
                    <div className="tm_invoice_right tm_text_right">
                      <p className="tm_mb2"><b className="tm_primary_color">Invoice From:</b></p>
                      <p>
                        {supplier_name} <br />
                        {supplier_address}<br />
                        GSTIN: {supplier_gstno}
                      </p>
                    </div>
                  </div>
                  <div className="tm_table tm_style1">
                    <div className="">
                      <div className="tm_table_responsive">
                        <table>
                          <thead>
                            <tr className="tm_accent_bg">
                              <th className="tm_width_3 tm_semi_bold tm_white_color">Inventory</th>
                              <th className="tm_width_4 tm_semi_bold tm_white_color">Description</th>
                              <th className="tm_width_1 tm_semi_bold tm_white_color">Qty</th>
                              <th className="tm_width_2 tm_semi_bold tm_white_color">Unit</th>
                              <th className="tm_width_4 tm_semi_bold tm_white_color">Cost Per Unit</th>
                              <th className="tm_width_2 tm_semi_bold tm_white_color tm_text_right">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="tm_width_3">{inventory}</td>
                              <td className="tm_width_4">Material</td>
                              <td className="tm_width_1">{inventory_quantity}</td>
                              <td className="tm_width_1">{inventory_unit}</td>
                              <td className="tm_width_2">{inventory_costperunit}</td>
                              <td className="tm_width_2 tm_text_right">{inventory_price}</td>
                            </tr>


                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="tm_invoice_footer tm_border_top tm_mb15 tm_m0_md">
                      <div className="tm_left_footer">
                        <p className="tm_mb2"><b className="tm_primary_color">Payment info:</b></p>
                        <p className="tm_m0">{paid_at !== "" ? converttime(paid_at) : ""} <br />{billstatus}<br />Amount: {(parseInt(inventory_total)) + (((parseInt(inventory_total)) * 18) / 100)}</p>
                        <br />
                        <p className="tm_m0"><span ref={ref} /></p>
                      </div>
                      <div className="tm_right_footer">
                        <table className="tm_mb15">
                          <tbody>
                            <tr className="tm_gray_bg ">
                              <td className="tm_width_3 tm_primary_color tm_bold">Subtotal</td>
                              <td className="tm_width_3 tm_primary_color tm_bold tm_text_right">Rs. {parseInt(inventory_total)}</td>
                            </tr>
                            <tr className="tm_gray_bg">
                              <td className="tm_width_3 tm_primary_color">SGST <span className="tm_ternary_color">(9%)</span></td>
                              <td className="tm_width_3 tm_primary_color tm_text_right">Rs. {((parseInt(inventory_total)) * 9) / 100}</td>
                            </tr>
                            <tr className="tm_gray_bg">
                              <td className="tm_width_3 tm_primary_color">CGST <span className="tm_ternary_color">(9%)</span></td>
                              <td className="tm_width_3 tm_primary_color tm_text_right">Rs. {((parseInt(inventory_total)) * 9) / 100}</td>
                            </tr>
                            <tr className="tm_accent_bg">
                              <td className="tm_width_3 tm_border_top_0 tm_bold tm_f16 tm_white_color">Grand Total	</td>
                              <td className="tm_width_3 tm_border_top_0 tm_bold tm_f16 tm_white_color tm_text_right">Rs. {(parseInt(inventory_total)) + (((parseInt(inventory_total)) * 18) / 100)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                  <div className="tm_note tm_text_center tm_font_style_normal">
                    <hr className="tm_mb15" />
                    <p className="tm_mb2"><b className="tm_primary_color">Terms & Conditions:</b></p>
                    <p className="tm_m0">Invoice was created on a computer and is valid without the signature and seal.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>}</>}
    </Fragment>
  );
}

export default Invoice;